import { LocalePlayer } from '../en/player'

const player: LocalePlayer = {
  searchPlayers: 'Cari Pemain',
  playerProfile: 'Profil Pemain',
  MALE: 'LELAKI',
  FEMALE: 'PEREMPUAN',
  signUpToSeeInfo: 'Daftar untuk Melihat Statistik Pemain & Sejarah Perlawanan',
  loginToSeeInfo: `Log Masuk atau buat akaun untuk melihat rekod kemenangan-kekalahan pengguna ini, purata mata yang diperoleh, purata
  DUPRs rakan dan lawan, separuh hayat, sejarah perlawanan dan banyak lagi.`,
  profileUnlock: {
    title: 'Guna buka kunci?',
    subtitle: 'Guna satu tontonan profil percuma anda',
    unlock: 'Buka kunci',
    limitReached: 'Had dicapai',
    limitReachedSubtitle: 'Naik taraf ke DUPR+ untuk profil tanpa had',
    upgrade: 'Naik taraf',
    upgradeLink: 'Naik taraf untuk tanpa had',
    viewsLeftShort_one: '{{count}} lagi',
    viewsLeftShort_other: '{{count}} lagi',
    infoTitle: 'Tontonan profil percuma',
    info: 'Anda mempunyai {{count}} tontonan profil percuma.',
    resets: 'Ditetapkan semula {{when}}.',
    banner: {
      viewsLeft_one: '{{count}} tontonan lagi',
      viewsLeft_other: '{{count}} tontonan lagi',
      runningLow: 'Anda hampir kehabisan',
      freeViewsLeft_one: '{{count}} tontonan profil percuma lagi',
      freeViewsLeft_other: '{{count}} tontonan profil percuma lagi',
      unlockUnlimited: 'Buka Kunci Profil Tanpa Had',
    },
  },
  filterRatingLocked: 'Naik taraf ke DUPR+ untuk menapis mengikut penarafan',
  ratingLocked: 'Penarafan dikunci',
}

export default player
